/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const Screen = styled.div`
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    gap: 24px;
`;

export const Headline = styled.h1`
    width: 363px;
    height: 78px;
    margin: 0;
    padding: 0;

    font-family: "Custora";
    font-weight: 400;
    font-size: 28px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #e9ecf5;
`;

export const Subhead = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #b7bdcb;
`;

export const FullWidth = styled.div`
    width: 100%;
`;

export const PrimaryButton = styled.button`
    width: 100%;
    height: 48px;

    background: #5e84ed;
    border: none;
    border-radius: 10px;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 44.61px;
    letter-spacing: 0px;
    text-align: center;

    color: #ffffff;

    cursor: pointer;

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const ErrorText = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 15.60px;
    color: #ff8a8a;
`;

export const SpinnerWrap = styled.div`
    margin-top: 12px;
    display: grid;
    place-items: center;
`;

export const NormalInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Label = styled.span`
    color: #B7BDCB;
    font-size: 13px;
    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    line-height: 15.60px;
    word-wrap: break-word;
`;

export const InputAndErrorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const Input = styled.input`
    padding: 12px;
    background: #23252A;
    border-radius: 8px;
    outline: 1px #2B2D33 solid;
    outline-offset: -1px;
    align-items: center;
    gap: 10px;
    display: inline-flex;
    color: #E9ECF5;
    font-size: 16px;
    font-family: Inter;
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
    border: none;

    &::placeholder {
        color: #B7BDCB;
    }
    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;
